import gql from 'graphql-tag'

export const ME = gql`
  query ME {
    me {
      id
      phone
      name
      email
      ekyc {
        id
        phone
        nid
        status
        validate_by_nid
        parsonal {
          id
          name
          last_name
          father_name
          mother_name
          spouse_name
          age
          marital_status
          gender
          head_of_household
          education_level
          nid
          nid_front
          nid_back
          photo
          verifyed
          nid_photo
        }
        contact{
          id
          mobile
          other_phone
          email
          presentAddress{
            id
            division
            district
            thana
            address
            near_landmark
            postal_code
            house_hold_type
            living_in_this_address
          }
          permanentAddress{
            id
            pdivision
            pdistrict
            pthana
            paddress
            pnear_landmark
            ppostal_code
            phouse_hold_type
            pliving_in_this_address
            address_frm_nid
          }
        }
         occupation{
          id
          occupation_type
          occupation
          monthly_income
          name_of_Office_or_business
          designation
          job_length
          occupationAddress{
            id
            division
            district
            thana
            office_area
            address
            postal_code
          }
        }
        dependent{
          id
          number_of_child
          number_of_dependent
          depandantDetails{
            id
            relation
            name
            age
          }
        }
      }
      purchases{
      id
      used_location
      location
      status
      brand
      price_range
      guarantors{
        id
        name
        phone
        email
        relationship
        status
        token
      }
      showroom{
        id
        suffix
        emp_id
        manager_name
        phone
        email
        address
      }
      product{
        id
        product
        status
        brands{
          id
          brand
          status
        }
        prices{
          id
          price_range
          status
        }
      }

    }
    guarantors{
      id
      name
      phone
      email
      relationship
      status
      token
    }

    }
  }
`
